import AcuityBaseController from './acuity_base_controller'

export default class AcuityHelloController extends AcuityBaseController {
  static targets = ['name', 'output']

  greet () {
    this.outputTarget.textContent = `I'm AcuityHelloController. Hello, ${this.nameTarget.value}!`
  }
}
